import type { CommonProps } from "../common";
import type { UserProfile } from "../store/api";

export enum Display {
  AmilList,
  CollectionFitrah,
}

export function defaultDisplay(identity: string): Display {
  if (identity === "amil") {
    return Display.CollectionFitrah;
  }

  return Display.AmilList;
}

export type CommonPropsWithProfile = { profile: UserProfile } & CommonProps;

export interface MenuItem {
  subheader: string;
  menu: { key: Display; text: string; icon: JSX.Element; module: string }[];
  module: string;
}

export type Modules = { [key: string]: string[] };
